/**
 * ColorSwatches — selector de color de marca para reportes.
 * Paleta predefinida + selector de color personalizado (input type="color").
 * Usado por Reporte Ejecutivo y por los Estados de Cuenta CxC/CxP.
 */
export const COLOR_DEFAULT = "#f97316";
export const PALETA_PREDEFINIDA = [
  "#f97316", "#2563eb", "#16a34a", "#7c3aed", "#dc2626", "#4b5563", "#0891b2", "#facc15",
];

export function ColorSwatches({ value, onChange }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
      {PALETA_PREDEFINIDA.map(c => {
        const active = value.toLowerCase() === c.toLowerCase();
        return (
          <button key={c} type="button" onClick={() => onChange(c)} title={c} style={{
            width: 32, height: 32, borderRadius: "50%", background: c, cursor: "pointer",
            border: active ? "3px solid var(--text-primary)" : "2px solid var(--border-card)",
            boxShadow: active ? `0 0 0 2px ${c}55` : "none",
            transition: "all 0.15s",
          }}/>
        );
      })}
      <label title="Color personalizado" style={{
        width: 32, height: 32, borderRadius: "50%", cursor: "pointer",
        border: "2px dashed var(--border-card)", position: "relative", overflow: "hidden",
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "conic-gradient(red, yellow, lime, cyan, blue, magenta, red)",
      }}>
        <input type="color" value={value} onChange={e => onChange(e.target.value)}
          style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}/>
      </label>
    </div>
  );
}
